<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'svelte-i18n';
	import { zendureRequest } from 'src/services/zendure_reqs';
	//Stores
	//Design system components
	import { Button, Input, toast, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { makeNumbersPrimaryAndBold } from 'src/helpers/utilities';
	import { real_id } from 'src/helpers/interface_helpers';

	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	let settings = $settingsStore;
	const min = 0,
		max = 1200;

	let inputLimit: number = settings?.inputLimit || 0;
	let cache: number = inputLimit;

	let loading = false;

	const setInputLimit = async () => {
		if (cache === inputLimit) return;

		if (inputLimit < min || inputLimit > max) {
			return toast.open({
				type: 'danger',
				title:
					$format('movement_limit_toast', {
						values: { min: min, max: max },
					}) || 'Values must be between min - max!',
			});
		}

		let res;
		loading = true;

		res = await zendureRequest(device.id, {
			input_limit: isNaN(Number(inputLimit)) ? 0 : Number(inputLimit),
		});
		if (res?.isok) {
			cache = inputLimit;
		}

		onSettingsResponse(res, device);
		loading = false;
	};
</script>

<Text styleType="controls-small" class="mb-s">
	{@html makeNumbersPrimaryAndBold(
		`${$format('input_limit_description', {
			default: `Set maximum input power to battery`,
		})}`,
	)}
</Text>

<Input
	aria-label={$format('input_set_input_limit', {
		default: 'Input set input limit',
	})}
	size="m"
	bind:value={inputLimit}
	icon="fas fa-solar-panel"
	type={'number'}
	step={1}
	{min}
	{max}
	info={$format('range_min_max_watts_value', {
		default: 'Range: {min} W - {max} W.',
		values: { min, max },
	})}
	error={inputLimit < min || inputLimit > max
		? $format('movement_limit_toast', {
				values: { min: min, max: max },
			}) || 'Values must be between min - max!'
		: ''}
	on:enter={setInputLimit}
	id="input-q3hi23a"
/>

<Button
	class="mt-s"
	{loading}
	size="m"
	width="full"
	disabled={inputLimit < min || inputLimit > max}
	on:click={setInputLimit}>{$format('button_save')}</Button
>
